/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductUpdateRequest {
  aboutTheBrand?: string;
  activeFeedbackId?: number;
  brandId?: number;
  categoryId?: number;
  defaultImageURL?: string;
  defaultProductVariantId?: number;
  descriptionArticleId?: number;
  differentials?: string;
  howToUse?: string;
  ingredients?: string;
  productId?: number;
  productName?: string;
  productSummary?: string;
  productTypeId?: number;
  showOnWebsite?: number;
  subscriptionId?: number;
  whoMustUse?: string;
}
